<ul id="accordion" class="accordion">

  @for (menu of menus; track menu.name) {
  <li [class.active]="menu.active">
    @if (menu.submenu.length == 0) {
    <div class="menu" (click)="toggle($index)">
      <a [routerLink]="menu.url">
        <fa-icon [icon]="menu.iconClass" class="menu.iconClass" size="2x"></fa-icon>
        {{menu.name}}
      </a>
    </div>
    }

    @if (menu.submenu.length > 0) {
    <div class="menu" (click)="toggle($index)">
      <fa-icon [icon]="menu.iconClass" class="menu.iconClass" size="2x"></fa-icon>
      {{ menu.name }}
      <fa-icon [icon]=chevronDown></fa-icon>
    </div>
    }

    @if (menu.submenu.length > 0) {
    <ul class="submenu" #submenu [style.height.px]="menu.active ? submenu.scrollHeight : 0">
      @for (submenu of menu.submenu; track submenu.url) {
      <li>
        <a [routerLink]="submenu.url">{{ submenu.name }}</a>
      </li>
      }
    </ul>
    }
  </li>
  }
</ul>